import {HistoricalPipeline} from "./historicalPipeline";

export class QuarterlyPipeline {
    quarter1;
    quarter2;
    quarter3;
    quarter4;

    constructor({quarter1Data, quarter2Data, quarter3Data, quarter4Data}) {
        this.quarter1 = new HistoricalPipeline({data: quarter1Data, quarter: 'Q1'});
        this.quarter2 = new HistoricalPipeline({data: quarter2Data, quarter: 'Q2'});
        this.quarter3 = new HistoricalPipeline({data: quarter3Data, quarter: 'Q3'});
        this.quarter4 = new HistoricalPipeline({data: quarter4Data, quarter: 'Q4'});
    }
}